export default __webpack_public_path__ + "dd247499d9554fc8984592b47bc3c71b.png";